export default "__VITE_ASSET__ANiVld8T__"